enum PagesEnum {
  Authorize = "authorize",
  Bell = "bell",
  Geolocation = "geolocation",
  Preferences = "preferences",
  ProofValue = "proof_value",
  Universes = "universes",
  Confirmation = "confirmation",
  Contact = "contact",
  Error = "error",
  Filters = "filters",
  FiltersCategory = "filters_category",
  Help = "help",
  Login = "login",
  NoResult = "no_result",
  Requests = "requests",
  RequestDetail = "request_details",
  RequestRecommendations = "list_of_recommendation",
  ResetPasswordStepNumber = "reset_password_step",
  Recommendation = "recommendation",
}

export default PagesEnum;
